import { Inject, Injectable, Optional } from '@angular/core';

import { Bloc, BLOC_DEBUG } from '@connect-services/client/blocs/bloc';
import { FieldInterventionFormsService } from '@connect-services/src/sdk/api';

@Injectable({
    providedIn: 'root',
})
export class FieldInterventionFormListBloc extends Bloc<
    FieldInterventionFormsService['fieldInterventionFormControllerGet']
> {
    public constructor(service: FieldInterventionFormsService, @Inject(BLOC_DEBUG) @Optional() debug?: boolean) {
        super(service.fieldInterventionFormControllerGet.bind(service), {
            debug: debug ?? false,
        });
    }
}
